export default "__VITE_ASSET__EGPmUNmL__"